import type { CommandShortcutsProps } from '@atlassian/jira-command-palette-common/src/ui/command-shortcuts/types.tsx';
import type { CommandsWithAction } from './types.tsx';

export function mapCommandsToShortcuts(commandsWithShortcut: Array<CommandsWithAction>) {
	if (!Array.isArray(commandsWithShortcut)) return null;
	if (commandsWithShortcut.length === 0) return null;

	const commandWithShortcut = commandsWithShortcut.filter((command) => command.shortcut);

	const initialValue: CommandShortcutsProps['keyMap'] = {};

	return commandWithShortcut.reduce((acc, command) => {
		acc[command.shortcut] = {
			callback: command.primaryAction.perform,
			registerInCommandPalette: {
				section: command.section,
				name: command.name,
				components: command.components,
			},
		};
		return acc;
	}, initialValue);
}
